export enum ProductSizeLabelType {
	Pieces = "Pieces",
	Serving = "Serving",
	Kilograms = "Kilograms",
	Grams = "Grams",
}
